<full-modal-config
    modalTitle="{{ l10nKeys.modalTitleEdit | vtranslate }}"
    [modified]="form.touched && form.dirty"
    (onCancel)="editable.dismiss(true)"
    (onSubmit)="savePortalInfoAndRegisterController()"
    [busy]="editable.isBusy() || busy"
    [errors]="editable.errors || error"
    [valid]="form.valid"
    class="cportal-info-modal"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section
            tabTitle="{{ globalL10nKeys.generalLabel | vtranslate }}"
            *ngIf="!editMode || isUpdateGeneralSectionDisabled"
        >
            <div class="full-modal-config__section">
                <h3>{{ globalL10nKeys.generalLabel | vtranslate }}</h3>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        for="cluster-name"
                        required
                    >
                        {{ l10nKeys.clusterNameLabel | vtranslate }}
                    </label>
                    <input
                        clrInput
                        fieldName="name"
                        [(ngModel)]="controllerName"
                        id="cluster-name"
                        name="name"
                        [disabled]="isUpdateGeneralSectionDisabled"
                        placeholder="{{ l10nKeys.clusterNamePlaceholder | vtranslate }}"
                        required
                    />
                </avi-input-container>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="site-name"
                            required
                        >
                            {{ l10nKeys.siteNameInputLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            [(ngModel)]="selectedSiteId"
                            [collection]="albServicesSiteCollection"
                            [disableCreate]="true"
                            [disabled]="isUpdateGeneralSectionDisabled"
                            [disableEdit]="true"
                            [hideSearch]="true"
                            [placeholder]="l10nKeys.siteInputPlaceholder | vtranslate"
                            [preventLoad]="true"
                            id="site-name"
                            name="site-name"
                            required
                        ></avi-collection-dropdown>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="contact"
                            required
                        >
                            {{ l10nKeys.contactInputLabel | vtranslate }}
                        </label>
                        <avi-dropdown
                            id="contact"
                            [options]="users"
                            name="contact"
                            [(ngModel)]="defaultContact"
                            placeholder="{{ l10nKeys.contactInputPlaceholder | vtranslate }}"
                            [disabled]="isUpdateGeneralSectionDisabled"
                            [hideSearch]="false"
                            required
                        ></avi-dropdown>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.proxyHeader | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.proxyHeader | vtranslate }}</h3>
                <avi-proxy [editable]="editable"></avi-proxy>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.smartOperationsHeader | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.smartOperationsHeader | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="enable_pulse_inventory"
                            fieldName="enable_pulse_inventory"
                            objectType="{{ objectType.PortalFeatureOptIn }}"
                        >
                            {{ l10nKeys.inventoryStatsLabel | vtranslate }}
                        </label>
                        <avi-checkbox
                            class="cportal-info-modal__label-font"
                            [noMarginTop]="true"
                            name="enable_pulse_inventory"
                            [(ngModel)]="editable.featureOptInStatusConfig.enable_pulse_inventory"
                        >
                            {{ l10nKeys.enableInventoryDashboardLabel | vtranslate }}
                        </avi-checkbox>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.threatIntelligenceHeader | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.threatIntelligenceHeader | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="enable_pulse_waf_management"
                            objectType="{{ objectType.PortalFeatureOptIn }}"
                            fieldName="enable_pulse_waf_management"
                        >
                            {{ l10nKeys.wafCrsLabel | vtranslate }}
                        </label>
                        <avi-fieldset
                            [hideContent]="!editable.featureOptInStatusConfig.enable_pulse_waf_management"
                            class="cportal-info-modal__case-management-checkbox-container"
                        >
                            <avi-fieldset_header>
                                <avi-checkbox
                                    class="cportal-info-modal__label-font"
                                    [noMarginTop]="true"
                                    name="enable_pulse_waf_management"
                                    [(ngModel)]="editable.featureOptInStatusConfig.enable_pulse_waf_management"
                                >
                                    {{ l10nKeys.enableWafCrsLabel | vtranslate }}
                                </avi-checkbox>
                            </avi-fieldset_header>
                            <avi-fieldset_content>
                                <label
                                    aviLabelWithTooltip
                                    objectType="{{ objectType.ALBServicesConfig }}"
                                    fieldName="case_config"
                                >
                                    {{ l10nKeys.signaturesLabel | vtranslate }}
                                </label>
                                <avi-checkbox-container-group [noMarginTop]="true">
                                    <avi-checkbox
                                        class="cportal-info-modal__label-font"
                                        name="enable_waf_signatures_notifications"
                                        fieldName="enable_waf_signatures_notifications"
                                        objectType="{{ objectType.WafCrsConfig }}"
                                        [(ngModel)]="editable.wafConfig.enable_waf_signatures_notifications"
                                    >
                                        {{ l10nKeys.enableCrsDataLabel | vtranslate }}
                                    </avi-checkbox>
                                    <avi-checkbox
                                        class="cportal-info-modal__label-font"
                                        name="enable_auto_download_waf_signatures"
                                        fieldName="enable_auto_download_waf_signatures"
                                        objectType="{{ objectType.WafCrsConfig }}"
                                        [(ngModel)]="editable.wafConfig.enable_auto_download_waf_signatures"
                                    >
                                        {{ l10nKeys.enableAutoDownloadWafLabel | vtranslate }}
                                    </avi-checkbox>
                                </avi-checkbox-container-group>
                            </avi-fieldset_content>
                        </avi-fieldset>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType.ALBServicesConfig }}"
                            fieldName="feature_opt_in_status"
                        >
                            {{ l10nKeys.appSignaturesSyncLabel | vtranslate }}
                        </label>
                        <div class="cportal-info-modal__alert">
                            <avi-alert-group
                                alertType="lightweight"
                                [hyperlink]="LINK"
                                deprecationLabel="{{ l10nKeys.deprecationWarningLabel | vtranslate }}"
                            ></avi-alert-group>
                        </div>
                        <avi-checkbox
                            [noMarginTop]="true"
                            name="enable_appsignature_sync"
                            fieldName="enable_appsignature_sync"
                            objectType="{{ objectType.PortalFeatureOptIn }}"
                            [(ngModel)]="editable.featureOptInStatusConfig.enable_appsignature_sync"
                        >
                            {{ l10nKeys.enableApplicationRulesDbLabel | vtranslate }}
                        </avi-checkbox>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="enable_ip_reputation"
                            objectType="{{ objectType.PortalFeatureOptIn }}"
                            fieldName="enable_ip_reputation"
                        >
                            {{ l10nKeys.ipReputationLabel | vtranslate }}
                        </label>
                        <avi-checkbox
                            [noMarginTop]="true"
                            name="enable_ip_reputation"
                            [(ngModel)]="editable.featureOptInStatusConfig.enable_ip_reputation"
                        >
                            {{ l10nKeys.enableAutoSyncIpLabel | vtranslate }}
                        </avi-checkbox>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            for="enable_user_agent_db_sync"
                            fieldName="enable_user_agent_db_sync"
                            objectType="{{ objectType.PortalFeatureOptIn }}"
                        >
                            {{ l10nKeys.botManagementLabel | vtranslate }}
                        </label>
                        <avi-checkbox
                            [noMarginTop]="true"
                            name="enable_user_agent_db_sync"
                            [(ngModel)]="editable.featureOptInStatusConfig.enable_user_agent_db_sync"
                        >
                            {{ l10nKeys.enableUserAgentDbManagementLabel | vtranslate }}
                        </avi-checkbox>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
